import PropTypes from 'prop-types';

const RangeSlider = ({
  value,
  min,
  max,
  step,
  values,
  minLabel,
  maxLabel,
  formattedValue,
  onChange,
  disabled = false,
}) => {
  const usesDiscreteValues = Array.isArray(values) && values.length > 0;
  const sliderMin = usesDiscreteValues ? 0 : min;
  const sliderMax = usesDiscreteValues ? values.length - 1 : max;
  const sliderStep = usesDiscreteValues ? 1 : step;
  const sliderValue = usesDiscreteValues
    ? Math.max(0, values.indexOf(value))
    : value;
  const progress = sliderMax === sliderMin
    ? 0
    : ((sliderValue - sliderMin) / (sliderMax - sliderMin)) * 100;

  const handleChange = (event) => {
    const nextValue = Number(event.target.value);
    if (usesDiscreteValues) {
      onChange(values[nextValue]);
      return;
    }
    onChange(nextValue);
  };

  return (
    <div className='digital-loan-range'>
      <p className='digital-loan-range__value font-bold text-center mb-4'>{formattedValue}</p>
      <input
        type='range'
        className='digital-loan-range__input'
        min={sliderMin}
        max={sliderMax}
        step={sliderStep}
        value={sliderValue >= 0 ? sliderValue : sliderMin}
        disabled={disabled}
        style={{
          background: `linear-gradient(to right, var(--primary-color) 0%, var(--primary-color) ${progress}%, #e5e5e5 ${progress}%, #e5e5e5 100%)`,
        }}
        onChange={handleChange}
        aria-valuemin={usesDiscreteValues ? values[0] : min}
        aria-valuemax={usesDiscreteValues ? values[values.length - 1] : max}
        aria-valuenow={value}
      />
      <div className='digital-loan-range__labels'>
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
    </div>
  );
};

RangeSlider.propTypes = {
  value: PropTypes.number.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  values: PropTypes.arrayOf(PropTypes.number),
  minLabel: PropTypes.string.isRequired,
  maxLabel: PropTypes.string.isRequired,
  formattedValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RangeSlider.defaultProps = {
  min: 0,
  max: 0,
  step: 1,
  values: null,
  disabled: false,
};

export default RangeSlider;
